export default __webpack_public_path__ + "static/media/on-the-rise-icon.72b978c7.svg";